import { IconButton, Tooltip } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { TextSpan } from '../../Atoms/Text';
import { ScheduleSetting } from '../../../store/ScheduleSettings';
import { SchedulePausedChip } from './SchedulePausedChip';
import { SchedulerInline, SchedulerInlineProps } from './SchedulerInline';

export interface SharedSchedulesListProps {
  schedules: ScheduleSetting[];
  activeKey: string | null;
  currentUserId: SchedulerInlineProps['currentUserId'];
  currentUserEmail: string;
  onToggle: (key: string) => void;
  onSave: SchedulerInlineProps['onSave'];
  onDelete: SchedulerInlineProps['onDelete'];
  onOptOut: SchedulerInlineProps['onOptOut'];
  onResume: SchedulerInlineProps['onResume'];
  onClose: () => void;
}

export const SharedSchedulesList = ({
  schedules,
  activeKey,
  currentUserId,
  currentUserEmail,
  onToggle,
  onSave,
  onDelete,
  onOptOut,
  onResume,
  onClose
}: SharedSchedulesListProps) => (
  <>
    <div className="mx-4 mt-3 mb-1">
      <TextSpan color="grey4">Shared with me</TextSpan>
    </div>
    {schedules.map((schedule) => {
      const schedulerKey = `shared:${schedule.id}`;
      return (
        <div
          className="border-b mx-4"
          key={schedule.id}>
          <div className="flex py-3 text-gray-400">
            <span className="self-center">{schedule.name}</span>
            {schedule.paused_at && (
              <span className="self-center ml-2">
                <SchedulePausedChip reason={schedule.paused_reason} />
              </span>
            )}
            <div className="ml-auto">
              <Tooltip title="View Schedule">
                <IconButton
                  sx={{ color: 'rgb(79 70 229)' }}
                  size="small"
                  aria-label="View schedule"
                  onClick={() => onToggle(schedulerKey)}>
                  <CalendarMonthIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          {activeKey === schedulerKey && (
            <div className="pb-3">
              <SchedulerInline
                viewKey={schedule.view_key}
                viewName={schedule.name}
                existingSchedule={schedule}
                currentUserId={currentUserId}
                currentUserEmail={currentUserEmail}
                onSave={onSave}
                onDelete={onDelete}
                onOptOut={onOptOut}
                onResume={onResume}
                onClose={onClose}
              />
            </div>
          )}
        </div>
      );
    })}
  </>
);
